module.exports = __webpack_public_path__ + "static/img/serviceAdvantages.79b9caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serviceAdvantages.png
// module id = V1z0
// module chunks = 16